module.exports = __webpack_public_path__ + "static/img/4.154d71e4.jpg";